import { useContext } from 'react';
import { ObjectAccessStateContext } from '../Context';

export const useObjectAccessState = () => {
  const reducer = useContext(ObjectAccessStateContext);

  return reducer;
};

export default useObjectAccessState;